import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const BasketUspsSkeleton = () => {
  return <UspsSkeletonBlock $width="100%" $height="170px" disableSpaceBelow />;
};

const UspsSkeletonBlock = styled(SkeletonBlock)`
  margin-bottom: 8px;
`;
